"use client"

// reCAPTCHA is now loaded on demand by lib/recaptcha-client.ts the first time a form is submitted,
// so nothing has to be mounted around the app (it used to load ~350 KB of Google script on every page).
export function ReCaptchaProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
